import { render, staticRenderFns } from "./settingDashboard.vue?vue&type=template&id=f1722f4e&scoped=true"
import script from "./settingDashboard.vue?vue&type=script&lang=js"
export * from "./settingDashboard.vue?vue&type=script&lang=js"
import style0 from "./settingDashboard.vue?vue&type=style&index=0&id=f1722f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1722f4e",
  null
  
)

export default component.exports